import React from 'react'
import { Share2 } from 'lucide-react'
import { Button } from './ui/button'
import { toast } from 'sonner'

export default function ShareButton({ url, title, size = 'sm', variant = 'outline', className = '' }) {
  const handleShare = async () => {
    const shareUrl = url || window.location.href
    const shareTitle = title || 'Public Respect'

    // Check if Web Share API is available (mobile)
    if (navigator.share) {
      try {
        await navigator.share({
          title: shareTitle,
          url: shareUrl,
        })
        toast.success('Shared successfully!')
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error('Share error:', err)
          fallbackShare(shareUrl)
        }
      }
    } else {
      fallbackShare(shareUrl)
    }
  }

  const fallbackShare = (shareUrl) => {
    // Desktop fallback: Use multiple methods
    
    // Method 1: Try modern clipboard API
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(shareUrl)
        .then(() => {
          toast.success('Link copied to clipboard!')
        })
        .catch((err) => {
          console.warn('Clipboard API failed, trying fallback method:', err)
          fallbackCopyMethod(shareUrl)
        })
    } else {
      // Method 2: Use legacy document.execCommand
      fallbackCopyMethod(shareUrl)
    }
  }

  const fallbackCopyMethod = (text) => {
    try {
      // Create temporary textarea element
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      
      const successful = document.execCommand('copy')
      document.body.removeChild(textarea)
      
      if (successful) {
        toast.success('Link copied to clipboard!')
      } else {
        // Last resort: Show the URL in a prompt
        showUrlPrompt(text)
      }
    } catch (err) {
      console.error('All copy methods failed:', err)
      showUrlPrompt(text)
    }
  }

  const showUrlPrompt = (text) => {
    // Show URL in prompt as last resort
    const input = prompt('Copy this link:', text)
    if (input !== null) {
      toast.info('Please copy the link manually')
    }
  }

  return (
    <Button
      onClick={handleShare}
      variant={variant}
      size={size}
      className={`flex items-center gap-2 ${className}`}
    >
      <Share2 className="w-4 h-4" />
      <span className="hidden sm:inline">Share</span>
    </Button>
  )
}
